<template lang="pug">
  .component-einvoice-status
    ActionButton(:action="getStatus", slot="trigger") Status SDI
    ModalReveal(v-model="openSdiStatus", @input="closeSdiStatus")
      .container(v-if="sdiStatus")
        .row
          .column
            h2 Status fattura
            .fname Nome file: {{sdiStatus.filename}}
            .ecode Errore: {{sdiStatus.errorCode}} {{sdiStatus.errorDescription}}
            .download Apri XML ricevuto dallo SDI
            .download (CTRL+U per vedere il contenuto)
            a.fa.fa-code.fa-2x(@click="openSentXml")

            hr
            .status(v-for="status in sdiStatus.invoices")
              .line N° {{status.number}} - {{status.status}} {{status.description}}
              .line {{status.statusDescription}}
</template>

<script>
  import ModalReveal from '../../../structure/foundation/ModalReveal'
  import KeplerBackofficeSdk from '../../../../lib/kepler/backoffice'
  import ActionButton from '../../../structure/ui/ActionButton'

  export default {
    name: 'EinvoiceGetStatus',
    components: {ActionButton, ModalReveal},
    data() {
      return {
        sdiStatus: null,
        openSdiStatus: false,
      }
    },
    methods: {
      closeSdiStatus() {
        this.sdiStatus = null
        this.openSdiStatus = false
      },
      getStatus() {
        return KeplerBackofficeSdk.invoices.select(this.invoice).getStatus((data) => {
          this.sdiStatus = data
          this.openSdiStatus = true
        })
      },
      openSentXml() {
        let blob = new Blob([atob(this.sdiStatus.file)], {type: 'text/xml'})
        let url = URL.createObjectURL(blob)
        window.open(url)
      }
    },
    props: ['invoice']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// EinvoiceGetStatus.vue?bb857a38